<ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false">
  <ziro-radio [fieldId]="'ssoEnabled'"></ziro-radio>
</ziro-collapsible-section-card>
